import 'moment-timezone';


const TableChoiceGroup = (props) => {

    const onClickRadio = (e) => {
        const idx = parseInt(e.target.value);
        props.setItem({...props.items.current.showed[idx]})
    };

    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th style={{width: "30px"}}></th>
                <th>Nombre</th>
            </tr>
            </thead>
            <tbody>
            {
                props.itemsShow.map((item, index) => (
                    <tr key={index} data-idx={index} onClick={onClickRadio}>
                        <td>
                            <input type="radio" name="radioContainer" value={index}/>
                        </td>
                        <td>{item.name}</td>
                    </tr>
                ))
            }
            </tbody>
        </table>
    );
}

export default TableChoiceGroup

